export default class PrecomputedMeshSource {
    constructor({ url, requestInit }) {
        this.url = url;
        this.requestInit = requestInit;
    }
}
//# sourceMappingURL=NgPassthroughSource.js.map